import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'
import { PriceDisplayProps } from '../types'
import { formatPercent, formatPrice } from '../utils'

const PriceDisplay: React.FC<PriceDisplayProps> = ({ 
  change, 
  changePercent, 
  price, 
  symbol 
}) => {
  const isPositive = changePercent >= 0
  const changeColor = isPositive ? 'green.400' : 'red.400'
  
  return (
    <Box>
      <Flex align="baseline">
        <Text fontSize="3xl" fontWeight="bold" mr={2}>
          {formatPrice(price)}
        </Text>
        <Text color="gray.500" fontSize="lg">
          {symbol}
        </Text>
      </Flex>
      
      <Flex align="center">
        <Text 
          color={changeColor} 
          fontSize="md" 
          fontWeight="medium"
        >
          {isPositive ? '+' : ''}{formatPrice(change)} ({formatPercent(changePercent)})
        </Text>
      </Flex>
    </Box>
  )
}

export default PriceDisplay
